<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <a :href="`/users/${user.key}`">
            <avatar :user="user" />
            <h1 style="display: inline; font-size: x-large;">{{ user.name }}</h1>
          </a>
        </div>
        <div class="mb-2">
          {{ user.description }}
        </div>
        <div class="d-flex">
          <div class="mr-2">
            🌏 {{ user.mag_count }} <span style="color: gray;">まぐわった</span>
          </div>
          <div class="mr-2" v-if="isProfilePage">
            🔒 {{ user.private_mag_count }} <span style="color: gray;">まぐわった</span>
          </div>
        </div>
        <div class="mr-2" v-if="user.twitter_screen_name">
          <a :href="user.twitter_url" target="_blank">
            <i class="fab fa-twitter" />
            {{ user.twitter_screen_name }}
          </a>
        </div>
      </div>
      <div class="col-md-6">
        <hr class="d-md-none"/>
        <chart :mags="user.mags_for_stats" v-if="isCurrentUserPage || isProfilePage" :is-profile-page="isProfilePage" />
        <grass :mags="user.mags_for_stats" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import Grass from '../charts/_grass'
import Chart from '../charts/_show'
import Avatar from './_avatar'

export default {
  components: { Grass, Chart, Avatar },
  props: ['user', 'isCurrentUserPage', 'isProfilePage'],
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
